import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useWallet, UseWalletProvider } from 'use-wallet';
import vj from './Im/Vijay.png';
import meta from './Im/meta1.png';
import torous from './Im/torous.png';
import fortmatic from './Im/fortmatic.png';
import './Wallet.css';
import { Link } from "react-router-dom";
import com_logo from "../Home/Home_modules/Im/com_logo.png";
import wallet_close from "./Im/wallet_close.png";
import Wallet_connected from './Im/Wallet_connect.jpg';
import firebaseConfig from '../fire';
import { FortmaticConnector } from '@web3-react/fortmatic-connector'
import Wallet_model from './Wallet_modal'
import WalletConnect from '@walletconnect/client';
import QRCodeModal from "@walletconnect/qrcode-modal";
import { toast } from "react-toastify";
const previousUrl = localStorage.getItem('currentUrl');

export function wc() {
  const connector = new WalletConnect({
    bridge: "https://bridge.walletconnect.org", // Required
    qrcodeModal: QRCodeModal,
  });



  // Check if connection is already established
  if (!connector.connected) {
    // create new session
    connector.createSession();
    connector.on("connect", (error, payload) => {
      if (error) {
        throw error;
      }
      // Get provided accounts and chainId
      const { accounts } = payload.params[0];
      console.log(accounts);
      const account = accounts[0];
      console.log(account);
      localStorage.setItem('Fortmatic Address', account);
      localStorage.setItem('LAST_ACTIVE_ACCOUNT', account);
      toast.success("Wallet Connected");
      //console.log(previousUrl);
      return <Redirect to={previousUrl} />;
    });
  }
  else {


  }


}

function Wallets() {
  firebaseConfig.auth().onAuthStateChanged(function (user) {
    if (user) {
      //Here you can place the code that you want to run if the user is logged in
    } else {
      window.location.href = "../login";
    }
  });
  //const authereum = new AuthereumConnector({ chainId: 42 })
  const wallet = useWallet()
  const { getweb3 } = Wallet_model();
  const [setMyWeb3] = useState();
  async function connectWallet() {
    await getweb3().then((response) => {
      setMyWeb3(response);
      response.eth.getAccounts().then((result) => (
        console.log(result)
      ));
    });
  };


  return (


    <div>
      <div className="all_wallet">
        <div className="rajini">
          <img className="wallet-im" src={vj} alt="Logo" />
          <div className="logo-sec">
            <Link to="/"><img className="wallet-com-logo" src={com_logo} alt="Logo" /></Link>
          </div>

        </div>



        {wallet.status === 'connected' ? (

          <div className="meta-connection">
            <Link to="/"><img className="wallet-close" src={wallet_close} alt="Logo" /></Link>
            <div>
              <h3 class="text-success">Connected Successfully</h3>
              <h4 class="m-wallet-address">Account: {wallet.account}</h4></div>
            {localStorage.setItem('LAST_ACTIVE_ACCOUNT', wallet.account)}
            <div><h3>Balance: {wallet.balance}</h3></div>
            <button className="resetbtt" onClick={() => wallet.reset()} >Disconnect</button>


          </div>
        ) : (


          <div className="topic">

            <Link to="/"><img className="wallet-close" src={wallet_close} alt="Logo" /></Link>


            <div className="">



              <div className="containerr">
                <h1 className="wallet-main-heading">Connect your wallet</h1>
                <p className="explain-text">Connect with any one of available wallet provider or create new.</p>
                <Link to="/how%20it%20works"><p className="wallet-head-2">What is wallet? Learn more</p></Link>
              </div>

            </div>



            <div className="ca-all"  >

              <div className="card" onClick={() => wallet.connect()} >
                <div className="card-body">
                  <img className="walletlogo" src={meta} alt="Logo" />


                  <div className="wallet-text"   >
                    <p className="card-heading">Metamask</p>
                    <p className="explain">The most trusted way to access store and swape the eth</p>
                  </div>
                </div>
              </div>



              <div className="card2" onClick={() => wallet.connect('torus')}>
                <div className="card-body">
                  <img className="walletlogo" src={torous} alt="Logo" />

                  <div className="wallet-text">
                    <p className="card-heading">Torus</p>
                    <p className="explain">Connect with your Google,Facebook,Discord,<br></br>Twitter</p>
                  </div>

                </div>
              </div>

              {/* <div className="card3"   onClick={() => wallet.connect('walletconnect')} > */}

              <div className="card3" onClick={wc} >
                <div className="card-body">
                  <img className="walletlogo2" src={Wallet_connected} alt="Logo" />


                  <div className="wallet-text"   >
                    <p className="card-heading">WalletConnect</p>
                    <p className="explain">WalletConnect is not an app  but an open protocol.</p>
                  </div>
                </div>
              </div>
              {/* onClick={Fort}  */}

              <div className="card2" onClick={() => wallet.connect('fortmatic')}>
                <div className="card-body">
                  <img className="walletlogo" src={fortmatic} alt="Logo" />

                  <div className="wallet-text">
                    <p className="card-heading">Fortmatic</p>
                    <p className="explain">Connect with your Email or <br></br>Phone</p>
                  </div>

                </div>
              </div>
              {/*<div className="temp-connect">
          {web3Loading? <button className =" btn-inner - text "disabled> Loading ... </button>: <button className =" btn-inner - text "onClick = {connectWallet}>Connect</button>}
      </div> */}








            </div>


            <div className="wallet-block-2">
              <div className="wallet-block2-text">
                <p className="wallet-block-2-learn">Learn which wallet work for you</p>
                <div className="wallet-how">
                  <p className="wallet-head-2 wallet-head2-m">How to get started?</p>
                  <p className="wallet-how-para">Learn to create,connect and intergrate the wallet of your choice to our portal</p>
                </div>

                <div className="wallet-video">
                  <iframe width="346" height="210" src="https://www.youtube.com/embed/-Bx_w820JwI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>





              </div>

              <div className="wallet-bt">


                <Link to="/how%20it%20works"  ><button id="wallet-btt" className="walletbtn">WHY USE THE WALLET</button></Link>

              </div>






            </div>





          </div>



        )}



      </div>

    </div>








  )
}








export default () => (
  <UseWalletProvider
    chainId={1}
    connectors={{
      // This is how connectors get configured
      //portis: { dAppId: '80c79304-55ca-4f65-9f68-6a0e48d9165c' },
      // rpc: { [chainId: 1] : 'https://rpc-mainnet.matic.network' },


      //  bridge?: 'https://bridge.walletconnect.org',
      //   qrcode?: 1,
      //   url: 'https://mainnet.infura.io/v3/5b9cdbc4c85947dd90e13c0bd2f0c5a6',
      //  appName: 'Diginoor',
      //   appLogoUrl: 'https://diginoor.com/logo.png',


      //  walletconnect : new WalletConnectConnector({ rpcUrl: { 1: ' https://rpc-mainnet.maticvigil.com/' } }),

      //  walletconnect:{rpcUrl:' https://rpc-mainnet.maticvigil.com/'},


      fortmatic: new FortmaticConnector({ apiKey: 'pk_live_F41C656E428A76F3', chainId: 4 }),
      walletconnect: { rpc: { 1: 'https://rpc-mainnet.maticvigil.com/' } },

    }}


  >
    <Wallets />


  </UseWalletProvider>
)



